// Generate unique IDs for use as pseudo-private/protected names.
// Similar in concept to
// <http://wiki.ecmascript.org/doku.php?id=strawman:names>.
//
// The goals of this function are twofold:
//
// * Provide a way to generate a string guaranteed to be unique when compared
//   to other strings generated by this function.
// * Make the string complex enough that it is highly unlikely to be
//   accidentally duplicated by hand (this is key if you're using `ID`
//   as a private/protected name on an object).
//
// Use:
//
//     var privateName = ID();
//     var o = { 'public': 'foo' };
//     o[privateName] = 'bar';

const generateId = () => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  return Math.random().toString(36).substr(2, 9);
};

const addScrollListener = (fun) => document.addEventListener('scroll', fun);
const removeScrollListener = (fun) =>
  document.removeEventListener('scroll', fun);

const hideFixedActionsBar = (fixedBarId) => {
  const fixBar = document.getElementById(fixedBarId);
  const content = document.getElementById('content');

  if (fixBar && content) {
    const bottomScroll =
      window.innerHeight + (window.scrollY || window.pageYOffset);
    const scrollEnd = bottomScroll === document.body.scrollHeight;
    const researchEndContent =
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      bottomScroll > content.getBoundingClientRect().height - 30;

    if (scrollEnd || researchEndContent) {
      fixBar.classList.add('content__base__page__actions__backgroud_hidden');
    } else {
      fixBar.classList.remove('content__base__page__actions__backgroud_hidden');
    }
  }
};

const executeWhenElChange = (elId, fun, timeOut) => {
  const targetNode = document.getElementById(elId);

  if (!targetNode) {
    return null;
  }

  const config = { attributes: false, childList: true, subtree: true };

  const callback = () => {
    setTimeout(fun, timeOut);
  };

  const observer = new MutationObserver(callback);

  observer.observe(targetNode, config);

  return observer;
};

export {
  generateId,
  hideFixedActionsBar,
  executeWhenElChange,
  addScrollListener,
  removeScrollListener
};
